<template>
  <div>
    <div id="nav">
      <div class="inner-nav">
        <div class="logo">
          <img
            alt="Logo de pagando check"
            src="./assets/logo-pagando-check.svg"
            height="41"
            width="112"
          />
        </div>
        <div style="display: flex; align-items: center;">
          <a class="link-display" href="https://www.pagandocheck.com/">
            Inicio
          </a>
          <div class="dropdown link-display">
            <button onclick="myFunction()" class="dropbtn">Productos</button>
            <div id="myDropdown" class="dropdown-content">
              <a href="https://www.pagandocheck.com/pagando-check-pro-acepta-pagos/">
                <img
                  alt="Imagen topbar"
                  src="./assets/terminal-check.png"
                  height="120"
                  width="120"
                />
                <strong>Terminal</strong>
                <p>Acepta pagos en tus establecimientos o en ventas a domicilio</p>
              </a>
              <a href="https://www.pagandocheck.com/pagando-check-link/">
                <img
                  alt="Imagen topbar"
                  src="./assets/checklink-cube.png"
                  height="120"
                  width="120"
                />
                <strong>Check Link</strong>
                <p>Cobra a distancia tus ventas por redes sociales a través de enlaces</p>
              </a>
              <a href="https://www.pagandocheck.com/procesador-pagos-online/#section-api">
                <img
                  alt="Imagen topbar"
                  src="./assets/api-cube.png"
                  height="120"
                  width="120"
                />
                <strong>API de pago</strong>
                <p>Integra la API de pagos a tu sitio web y comienza a recibir pagos por internet</p>
              </a>
              <a href="https://www.pagandocheck.com/procesador-pagos-online/#section-plugin">
                <img
                  alt="Imagen topbar"
                  src="./assets/plugins-top.png"
                  height="120"
                  width="120"
                />
                <strong>Plugins</strong>
                <p>Usa nuestros plugins para cobrar en tus plataformas de e-commerce</p>
              </a>
            </div>
          </div>

          <a class="link-display" href="https://www.pagandocheck.com/comisiones/">
            Comisiones
          </a>
          <a class="link-display" href="https://www.pagandocheck.com/procesador-pagos-online/">
            Desarrolladores
          </a>
          <a class="link-display" href="https://www.pagandocheck.com/contacto-pagando-check/">
            Contacto
          </a>
          <a class="link-display" href="https://app.pagandocheck.com/signin">
            <span class="pink-link">
              Iniciar sesión
            </span>
          </a>
          <a class="link-display" href="https://www.pagandocheck.com/contacto-pagando-check/#cita-ejecutivo">
            <span class="pink-btn">
              Comienza ahora
            </span>
          </a>
          <div class="responsive-menu-container" id="openMenu" onclick="openMenu()">
            <button class="responsive-menu">
              <img class="open-icon"
                alt="Logo de menu de barra superior de pagando"
                src="./assets/burger-icon.svg"
              />
              <svg class="close-icon" fill="currentColor" 
              version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" 
              height="24" viewBox="0 0 24 24">
                <path fill="#fff" d="M5.293 6.707l5.293 5.293-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l5.293-5.293 5.293 5.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-5.293-5.293 5.293-5.293c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"></path>
              </svg>
            </button>
            <div class="responsive-menu-box">
              <a href="https://www.pagandocheck.com/">
                Inicio
              </a>
              <a href="https://www.pagandocheck.com/comisiones/">
                Comisiones
              </a>
              <a href="https://www.pagandocheck.com/procesador-pagos-online/">
                Desarrolladores
              </a>
              <a href="https://www.pagandocheck.com/contacto-pagando-check/">
                Contacto
              </a>
              <a href="https://app.pagandocheck.com/signin">
                <span class="pink-link">
                  Iniciar sesión
                </span>
              </a>
              <a href="https://www.pagandocheck.com/contacto-pagando-check/#cita-ejecutivo">
                <span class="pink-link">
                  Comienza ahora
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <input class="modal-state" id="modal-1" type="checkbox" />
    <div class="modal">
      <label class="modal__bg" for="modal-1"></label>
      <div class="modal__inner">
        <label class="modal__close" for="modal-1"></label>
        <div class="title-modal">¿Cuál plugin quieres instalar?</div>
        <div class="plugin-container">
          <a href="/woocommerce">
            <img src="./assets/woocomerce-vertical.svg" alt="Logo de Woo commerce" width="180" height="130">
          </a>
          <a href="/magento">
            <img src="./assets/magento-vertical.svg" alt="Logo de Magento" width="180" height="130">
          </a>
          <a href="/prestashop">
            <img src="./assets/prestashop-vertical.svg" alt="Logo de Prestashop" width="180" height="130">
          </a>
        </div>
      </div>
    </div>
  </div>
  <router-view />
</template>

<style>
#nav {
  position: fixed;
  z-index: 9;
  top: 17px;
  width: 100%;
  left: 50%;
  transform: translate(-50%, 0%);
  padding: 0 34px;
}
.inner-nav {
  margin: auto;
  max-width: calc(1220px - 60px);
  background: #fff;
  box-shadow: 0px 18px 30px 4px rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(14px);
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
  height: 80px;
  width: calc(100% - 40px);
}
#nav .logo {
  width: 112px;
}
#nav .logo img {
  width: 100%;
}
#nav a {
  font-family: Poppins, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  color: #3c3e6a !important;
  text-decoration: none !important;
  padding: 0px 12px;
  position: relative;
  transition: 0.3s;
}
#nav a:last-child {
  padding-right: 0px !important;
}
.pink-link {
  color: #e40096 !important;
}
.pink-btn {
  color: #fff !important;
  background: #e40096 !important;
  padding: 10px 40px;
  border-radius: 6px;
  display: inline-block;
}
#nav a:hover {
  color: #e40096 !important;
}
#nav .router-link-active {
  pointer-events: none;
}
#nav .router-link-active::after {
  content: "";
  width: 40px;
  height: 0px;
  background-color: #e40096;
  border-radius: 20px;
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translate(-50%, 0%);
  border: 2px solid #e40096;
}
rapi-doc::part(section-main-content) {
      padding-bottom: 80px;
    overflow: initial !important;
    width: 100%;
}
.responsive-menu {
  border: none;
  height: 46px;
  border-radius: 6px;
  width: 46px;
  background: #E40096;
  cursor: pointer;
  display: none;
}
.responsive-menu-box {
  background-color: #ffffff;
  height: 0px;
  display: grid;
  width: calc(100% - 80px);
  border-radius: 6px;
  box-shadow: 0px 18px 30px 4px rgb(0 0 0 / 15%);
  top: 95px;
  overflow: hidden;
  transition: .3s;
  margin: 0 auto;
  left: 0;
  right: 0;
  position: fixed;
}
.open .responsive-menu-box {
  height: 348px;
}
.responsive-menu-box a {
  height: 58px;
  display: flex;
  justify-content: unset;
  align-items: center;
}
.close-icon {
  display: none;
}
.open .close-icon{
  display: initial;
}
.open .open-icon{
  display: none;
}
@media screen and (max-width: 991px) {
  .link-display {
    display: none;
  }
  .inner-nav {
    width: calc(100% - 80px);
  }
  .responsive-menu {
    display: initial;
  }
}

#rapi-doc::part(my-part) {
  color: red !important;
}

</style>
